import React from "react";

const RiskAssessment = ({ formData, handleChange, setActiveTab, errors = {} }) => {
    return (
        <div id="risk-assessment" className="content">
            <div className="row g-4 justify-content-center">

                {/* ====================== Section A: Suicide Risk ====================== */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Section A: Suicide Risk
                    </small>

                    {/* Suicidal Thoughts */}
                    <div className="mb-3">
                        <label className="fw-semibold d-block mb-2">Suicidal Thoughts: <span className="text-danger">*</span></label>
                        {["Yes", "No"].map((option) => (
                            <div className="form-check form-check-inline" key={option}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id={`suicidalThoughts-${option}`}
                                    name="suicidalThoughts"
                                    value={option}
                                    checked={formData.suicidalThoughts === option}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor={`suicidalThoughts-${option}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                        {errors.suicidalThoughts && (
                            <small className="text-danger d-block mt-2">{errors.suicidalThoughts}</small>
                        )}
                    </div>

                    {/* Frequency */}
                    <div className="mb-3">
                        <label className="fw-semibold d-block mb-2">Frequency of suicidal thoughts:</label>
                        {["Rare", "Occasional", "Frequent"].map((option) => (
                            <div className="form-check form-check-inline" key={option}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id={`suicideFrequency-${option}`}
                                    name="suicideFrequency"
                                    value={option}
                                    checked={formData.suicideFrequency === option}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor={`suicideFrequency-${option}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                        {errors.suicideFrequency && (
                            <small className="text-danger d-block mt-2">{errors.suicideFrequency}</small>
                        )}
                    </div>

                    {/* Current or past suicide plans */}
                    <div className="mb-3">
                        <label className="fw-semibold d-block mb-2">Current or past suicide plans? <span className="text-danger">*</span></label>
                        {["Yes", "No"].map((option) => (
                            <div className="form-check form-check-inline" key={option}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id={`suicidePlans-${option}`}
                                    name="suicidePlans"
                                    value={option}
                                    checked={formData.suicidePlans === option}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor={`suicidePlans-${option}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                        {errors.suicidePlans && (
                            <small className="text-danger d-block mt-2">{errors.suicidePlans}</small>
                        )}
                    </div>

                    {/* Previous suicide attempts */}
                    <div className="mb-3">
                        <label className="fw-semibold d-block mb-2">Previous suicide attempts? <span className="text-danger">*</span></label>
                        {["Yes", "No"].map((option) => (
                            <div className="form-check form-check-inline" key={option}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id={`suicideAttempts-${option}`}
                                    name="suicideAttempts"
                                    value={option}
                                    checked={formData.suicideAttempts === option}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor={`suicideAttempts-${option}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                        {errors.suicideAttempts && (
                            <small className="text-danger d-block mt-2">{errors.suicideAttempts}</small>
                        )}

                        {formData.suicideAttempts === "Yes" && (
                            <div className="form-floating form-floating-outline mt-3">
                                <textarea
                                    className={`form-control ${errors.suicideAttemptsDetails ? 'is-invalid' : ''}`}
                                    name="suicideAttemptsDetails"
                                    value={formData.suicideAttemptsDetails}
                                    onChange={handleChange}
                                    placeholder="Provide details"
                                    rows="3"
                                ></textarea>
                                <label>Provide details</label>
                                {errors.suicideAttemptsDetails && (
                                    <div className="invalid-feedback">{errors.suicideAttemptsDetails}</div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* ====================== Section B: Escape Risk ====================== */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Section B: Escape Risk
                    </small>

                    {/* Desire to escape */}
                    <div className="mb-3">
                        <label className="fw-semibold d-block mb-2">Desire to escape? <span className="text-danger">*</span></label>
                        {["Yes", "No"].map((option) => (
                            <div className="form-check form-check-inline" key={option}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id={`desireEscape-${option}`}
                                    name="desireEscape"
                                    value={option}
                                    checked={formData.desireEscape === option}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor={`desireEscape-${option}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                        {errors.desireEscape && (
                            <small className="text-danger d-block mt-2">{errors.desireEscape}</small>
                        )}
                    </div>

                    {/* Past escape attempts */}
                    <div className="mb-3">
                        <label className="fw-semibold d-block mb-2">Past escape attempts? <span className="text-danger">*</span></label>
                        {["Yes", "No"].map((option) => (
                            <div className="form-check form-check-inline" key={option}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id={`escapeAttempts-${option}`}
                                    name="escapeAttempts"
                                    value={option}
                                    checked={formData.escapeAttempts === option}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor={`escapeAttempts-${option}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                        {errors.escapeAttempts && (
                            <small className="text-danger d-block mt-2">{errors.escapeAttempts}</small>
                        )}

                        {formData.escapeAttempts === "Yes" && (
                            <div className="form-floating form-floating-outline mt-3">
                                <textarea
                                    className={`form-control ${errors.escapeAttemptsDetails ? 'is-invalid' : ''}`}
                                    name="escapeAttemptsDetails"
                                    value={formData.escapeAttemptsDetails}
                                    onChange={handleChange}
                                    placeholder="Provide details"
                                    rows="3"
                                ></textarea>
                                <label>Provide details</label>
                                {errors.escapeAttemptsDetails && (
                                    <div className="invalid-feedback">{errors.escapeAttemptsDetails}</div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* ====================== Section C: Aggression Risk ====================== */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Section C: Risk of Aggression or Violence
                    </small>

                    {/* History of aggression */}
                    <div className="mb-3">
                        <label className="fw-semibold d-block mb-2">History of aggression? <span className="text-danger">*</span></label>
                        {["Yes", "No"].map((option) => (
                            <div className="form-check form-check-inline" key={option}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id={`historyAggression-${option}`}
                                    name="historyAggression"
                                    value={option}
                                    checked={formData.historyAggression === option}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor={`historyAggression-${option}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                        {errors.historyAggression && (
                            <small className="text-danger d-block mt-2">{errors.historyAggression}</small>
                        )}

                        {formData.historyAggression === "Yes" && (
                            <div className="form-floating form-floating-outline mt-3">
                                <textarea
                                    className={`form-control ${errors.historyAggressionDetails ? 'is-invalid' : ''}`}
                                    name="historyAggressionDetails"
                                    value={formData.historyAggressionDetails}
                                    onChange={handleChange}
                                    placeholder="Provide details"
                                    rows="3"
                                ></textarea>
                                <label>Provide details</label>
                                {errors.historyAggressionDetails && (
                                    <div className="invalid-feedback">{errors.historyAggressionDetails}</div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Current risk of harm */}
                    <div className="mb-3">
                        <label className="fw-semibold d-block mb-2">
                            Current risk of harm to others? <span className="text-danger">*</span>
                        </label>
                        {["Yes", "No"].map((option) => (
                            <div className="form-check form-check-inline" key={option}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id={`harmToOthers-${option}`}
                                    name="harmToOthers"
                                    value={option}
                                    checked={formData.harmToOthers === option}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor={`harmToOthers-${option}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                        {errors.harmToOthers && (
                            <small className="text-danger d-block mt-2">{errors.harmToOthers}</small>
                        )}

                        {formData.harmToOthers === "Yes" && (
                            <div className="form-floating form-floating-outline mt-3">
                                <textarea
                                    className={`form-control ${errors.harmToOthersDetails ? 'is-invalid' : ''}`}
                                    name="harmToOthersDetails"
                                    value={formData.harmToOthersDetails}
                                    onChange={handleChange}
                                    placeholder="Any specific individual(s)?"
                                    rows="3"
                                ></textarea>
                                <label>Any specific individual(s)?</label>
                                {errors.harmToOthersDetails && (
                                    <div className="invalid-feedback">{errors.harmToOthersDetails}</div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* ====================== Section D: Self-Harm Risk ====================== */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Section D: Self-Harm Risk
                    </small>

                    {/* History of self-harm */}
                    <div className="mb-3">
                        <label className="fw-semibold d-block mb-2">History of self-harm? <span className="text-danger">*</span></label>
                        {["Yes", "No"].map((option) => (
                            <div className="form-check form-check-inline" key={option}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id={`selfHarmHistory-${option}`}
                                    name="selfHarmHistory"
                                    value={option}
                                    checked={formData.selfHarmHistory === option}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor={`selfHarmHistory-${option}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                        {errors.selfHarmHistory && (
                            <small className="text-danger d-block mt-2">{errors.selfHarmHistory}</small>
                        )}

                        {formData.selfHarmHistory === "Yes" && (
                            <div className="form-floating form-floating-outline mt-3">
                                <textarea
                                    className={`form-control ${errors.selfHarmHistoryDetails ? 'is-invalid' : ''}`}
                                    name="selfHarmHistoryDetails"
                                    value={formData.selfHarmHistoryDetails}
                                    onChange={handleChange}
                                    placeholder="Provide details"
                                    rows="3"
                                ></textarea>
                                <label>Provide details</label>
                                {errors.selfHarmHistoryDetails && (
                                    <div className="invalid-feedback">{errors.selfHarmHistoryDetails}</div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Current self-harm urges */}
                    <div className="mb-3">
                        <label className="fw-semibold d-block mb-2">Current self-harm urges? <span className="text-danger">*</span></label>
                        {["Yes", "No"].map((option) => (
                            <div className="form-check form-check-inline" key={option}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id={`selfHarmUrges-${option}`}
                                    name="selfHarmUrges"
                                    value={option}
                                    checked={formData.selfHarmUrges === option}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor={`selfHarmUrges-${option}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                        {errors.selfHarmUrges && (
                            <small className="text-danger d-block mt-2">{errors.selfHarmUrges}</small>
                        )}

                        {formData.selfHarmUrges === "Yes" && (
                            <div className="form-floating form-floating-outline mt-3">
                                <textarea
                                    className={`form-control ${errors.selfHarmUrgesDetails ? 'is-invalid' : ''}`}
                                    name="selfHarmUrgesDetails"
                                    value={formData.selfHarmUrgesDetails}
                                    onChange={handleChange}
                                    placeholder="Specific actions considered"
                                    rows="3"
                                ></textarea>
                                <label>Specific actions considered</label>
                                {errors.selfHarmUrgesDetails && (
                                    <div className="invalid-feedback">{errors.selfHarmUrgesDetails}</div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* ====================== Recommended For ====================== */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Recommended For <span className="text-danger">*</span>
                    </small>
                    <div className="d-flex flex-column align-items-center">
                        {[
                            "Residential Rehab Program",
                            "Day Rehab Program",
                            "OPD Services outside TRH",
                        ].map((option) => {
                            const inputId = `recommendedFor-${option.replace(/\s+/g, "-")}`;
                            return (
                                <div className="form-check mb-2 w-100" key={option}>
                                    <input
                                        className="form-check-input me-2"
                                        type="checkbox"
                                        id={inputId}
                                        name="recommendedFor"
                                        value={option}
                                        checked={formData.recommendedFor.includes(option)}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor={inputId}>
                                        {option}
                                    </label>

                                    {option === "OPD Services outside TRH" &&
                                        formData.recommendedFor.includes("OPD Services outside TRH") && (
                                            <div className="form-floating form-floating-outline mt-3 col-md-12">
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.opdDetails ? 'is-invalid' : ''}`}
                                                    name="opdDetails"
                                                    value={formData.opdDetails}
                                                    onChange={handleChange}
                                                    placeholder="Other"
                                                />
                                                <label>Other</label>
                                                {errors.opdDetails && (
                                                    <div className="invalid-feedback">{errors.opdDetails}</div>
                                                )}
                                            </div>
                                        )}
                                </div>
                            );
                        })}
                    </div>
                    {errors.recommendedFor && (
                        <small className="text-danger d-block text-center mt-2">{errors.recommendedFor}</small>
                    )}
                </div>

                {/* ====================== Follow-Up Notes ====================== */}
                <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-3">
                        <textarea
                            className="form-control"
                            name="followUpNotes"
                            value={formData.followUpNotes}
                            onChange={handleChange}
                            placeholder="Follow-Up Notes"
                            rows="4"
                        ></textarea>
                        <label>Follow-Up Notes</label>
                    </div>
                </div>

                {/* ====================== Navigation Buttons ====================== */}
                <div className="col-12 d-flex justify-content-end mt-2">
                    <div className="col-md-2">
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm btn-prev w-100"
                            onClick={() => setActiveTab("physical-health")}
                        >
                            <i className="ri-arrow-left-line"></i> Previous
                        </button>
                    </div>
                    <div className="col-md-2">
                        <button type="submit" className="btn btn-primary btn-sm btn-submit ms-2 w-100">
                            Submit <i className="ri-check-line"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RiskAssessment;